import PropTypes from 'prop-types'

export const formPropTypes = PropTypes.shape({
  amount: PropTypes.number,
  reference: PropTypes.string,
})
